import { GridItem } from "commons/ui/Grid";

type PropsType = {
    extraClassName?: string;
    style?: React.CSSProperties;
};

function LineSeparator({ extraClassName, style }: PropsType) {
    return (
        <GridItem className={"col-xs-10-10"} style={style}>
            <div
                className={`line-separator ${extraClassName ?? ""}`}
                data-testid={"line-separator"}
            />
        </GridItem>
    );
}

export default LineSeparator;
